module.exports = "<div class=\"item\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 196
// module chunks = 0